import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs } from "react-router";
import { JOBS_QUERIES } from "~/shared/api/jobs/jobs.queries";
import { DEFAULT_TABLE_PARAMS, getTableParamsFromRequest } from "~/shared/util/tableHelpers";
import {
  ACTIVE_STATUSES_TABLE_PARAMS_ID,
  JOB_STATUS_LOG_TABLE_PARAMS_ID,
} from "~/team/views/JobEditStatusesView/JobEditStatusesView.constants";

export function jobEditStatusesViewLoader(queryClient: QueryClient, { params, request }: LoaderFunctionArgs) {
  try {
    const { jobId } = params ?? {};

    if (!jobId) {
      throw new Error("Job ID is required to load job statuses");
    }

    queryClient.ensureQueryData(
      JOBS_QUERIES.statusesList(
        jobId,
        getTableParamsFromRequest({
          key: ACTIVE_STATUSES_TABLE_PARAMS_ID,
          request,
        }),
      ),
    );

    queryClient.ensureQueryData(
      JOBS_QUERIES.statusesLogList(
        jobId,
        getTableParamsFromRequest({
          key: JOB_STATUS_LOG_TABLE_PARAMS_ID,
          request,
          fallbackData: {
            page: DEFAULT_TABLE_PARAMS.page,
            limit: DEFAULT_TABLE_PARAMS.limit,
          },
        }),
      ),
    );

    return null;
  } catch (error) {
    return null;
  }
}
